import { useState, useMemo } from 'react';

interface Props {
  data: any[] | undefined;
  fields: string[];
}

const useSearch = ({ data, fields }: Props) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredRows = useMemo(() => {
    if (searchQuery) {
      const searchWords = searchQuery.trim().toLowerCase().split(' ');

      return data?.filter((row) =>
        searchWords.every((word) =>
          fields.some((field) => {
            const fieldValueAsString =
              typeof row[field] === 'number' ? String(row[field]) : row[field];
            const stringValue =
              typeof fieldValueAsString === 'string' ? fieldValueAsString.toLowerCase() : '';
            return stringValue.includes(word);
          })
        )
      );
    }
    return data;
  }, [data, searchQuery, fields]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  return { handleSearchChange, filteredRows };
};

export { useSearch };
